var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loader)?_c('loader',{attrs:{"object":"#2E7D32","color1":"#398abe","color2":"#92c2bf","size":"10","speed":"2","objectbg":"#999793","opacity":"30","disableScrolling":"false","name":"circular"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }